import { create } from "zustand";
import courseService from "../services/courseService";
import lessonService from "../services/lessonService";

const useCourseStore = create((set) => ({
  course: null,
  lessons: [],
  currentLesson: null,

  fetchCourse: async (course_id) => {
    try {
      const course = await courseService.getCourseById(course_id)
      const lessons = await lessonService.getLessonByCourseId(course_id)
      console.log(lessons)
      set({course: course.data, lessons: lessons.data})

    } catch (error) {
      console.error(error)
    }
  },

  fetchLessonByCourseId: async (course_id) => {
    try {
      const lessons = await lessonService.getLessonByCourseId(course_id)
      set({lessons: lessons.data})
    } catch (error) {
      console.error(error)
    }
  },


  getCurrentLesson: async (lesson_id) => {
    try {
      const { lessons} = useCourseStore.getState()
      console.log('Test: ',lesson_id,lessons)
      const lesson = lessons.find(item => item.id == lesson_id)
      return lesson
    } catch (error) {

    }
  },


  getNextLesson: async (order) => {
    try {
      const { lessons} = useCourseStore.getState()
      const nextLesson = lessons[order] || {}
      return nextLesson
    } catch (error) {

    }
  },

  getPreviousLesson: async (order) => {
    try {
      const { lessons} = useCourseStore.getState()
      const previousLesson = lessons[order-2] || {}
      return previousLesson
    } catch (error) {

    }
  }



}
))

export default useCourseStore
